import React, { useEffect, useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert';
import {Button as MaterialButton } from '@material-ui/core/';
import ErrorMessage from '../Components/Message/errorMessage';
import SuccessMessage from '../Components/Message/successMessage';
import { listOrders, deleteOrder } from '../Actions/orderAction';
import TableLoader from '../Components/Loader/TableLoader';
import Print from '../Components/Print/Print';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import * as routes from '../Constants/routes';
import { createPdfData } from '../services/order';
import * as orderConstants from '../Constants/orderConstants';
import { interpolate } from '../utils/string';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const OrderList = () => {
  const orderList = useSelector((state) => state.orderList);
  const userLogin = useSelector((state) => state.userLogin);
  const [initialLoading, setInitialLoading] = useState(true);

  const { orders, loading, error, count, success } = orderList;
  const { userInfo } = userLogin;

  const dispatch = useDispatch();

  const deleteOrderData = useSelector((state) => state.deleteOrder);
  const { success: deleteSuccess, error: deleteFail } = deleteOrderData;

  useEffect(() => {
    dispatch(listOrders());

    // eslint-disable-next-line
  }, [dispatch, deleteSuccess,]);

  useEffect(() => {
    if (success && initialLoading) {
      setInitialLoading(false);
    }
    // eslint-disable-next-line
  }, [dispatch, success]);

  const printAs = (value) => {
    const downloadAs = value;

    switch (downloadAs) {
      case 'pdf':
        var docDefinition = createPdfData(userInfo, orders);

        pdfMake.createPdf(docDefinition).download('orders-list.pdf');

        break;
      case 'excel':
        break;

      default:
        break;
    }
  };

  const deleteHandler = (id, e) => {
    e.preventDefault();
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1 className="font-weight-bold text-white">Are you sure?</h1>
            <p>You want to delete this order?</p>
            <MaterialButton
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(deleteOrder(id));
                onClose();
              }}
            >
              Yes, Delete it !
            </MaterialButton>
            <MaterialButton variant="contained" color="primary" onClick={onClose}>
              No
            </MaterialButton>
          </div>
        );
      },
    });
  };

  return (
    <>
        {deleteSuccess && (
        <SuccessMessage
          header="Done"
          message="Order Deleted Successfully"
          reset={orderConstants.DELETE_ORDER_RESET}
        />
      )}
      {deleteFail && (
        <ErrorMessage
          header="Something went wrong"
          message={deleteFail}
          reset={orderConstants.DELETE_ORDER_RESET}
        />
      )}
      <div className="clearfix">
        <span className="float-left">
          <h1>Orders ({count})</h1>
        </span>

        <span className="float-right">
          {' '}
          <Print printAs={printAs} />
        </span>
      </div>

      {loading ? (
        <TableLoader />
      ) : error ? (
        <ErrorMessage header="Something went wrong" message={error} />
      ) : (
        <Table striped bordered hover responsive className="table-sm">
          <thead>
            <tr>
              <th>ID</th>
              <th>USER</th>
              <th>DATE</th>
              <th>TOTAL</th>
              <th>PAID</th>
              <th>DELIVERED</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order._id}>
                <td>{order._id}</td>
                <td>{order.userId && order.userId.name && order.userId.mobile}</td>
                <td>{order.createdAt}</td>
                <td>Ksh{order.totalPrice}</td>
                <td>
                  {order.isPaid ? (
                    order.paidAt
                  ) : (
                    <i className="fas fa-times" style={{ color: 'red' }}></i>
                  )}
                </td>
                <td>
                  {order.isDelivered ? (
                    order.deliveredAt
                  ) : (
                    <i className="fas fa-times" style={{ color: 'red' }}></i>
                  )}
                </td>
                <td>
                  <LinkContainer
                    to={interpolate(routes.ORDER, {
                      orderId: order._id,
                    })}
                  >
                    <Button variant="light" className="btn-sm">
                      Details
                    </Button>
                  </LinkContainer>
                  <Button variant="danger" className="btn-sm" onClick={(e) => deleteHandler(order._id, e)}>
                      <i className="fas fa-trash"></i>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default OrderList;
